<script setup>
  import { ref, inject, onMounted } from 'vue';
  import { useSpotStore } from "@/stores/SpotStore";
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';
  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const { $SHOWTEMPESTMETA } = useConfigurationGlobals();
  const { $STATION_INFO } = useContainerConfigurationGlobals();

  const content = defineModel('content');

  const spotStore = useSpotStore();

  const { stationMetaData } = useLegacyBridge();

  const isNCWind = inject('isNCWind');

  const contentContainer = ref(null);
  
  function loadStationInfo() {
    const settings = {
      spot: spotStore.spot,
      station: spotStore.defaultStation,
      spotName: spotStore.spotName,
      provider: spotStore.defaultStation.provider,
      sourceMessage: spotStore.sourceMessage,
      showFullMetadata: $STATION_INFO.show_full_metadata,
      showTempestMeta: $SHOWTEMPESTMETA,
      showTextOnly: true,
      isNCWind: isNCWind
    }       
    
    content.value = stationMetaData(contentContainer.value, settings);
  }

  onMounted(() => loadStationInfo());
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%; height: 100%;"
    ref="contentContainer"
  ></div>
</template>